export enum TransportType {
	UNKNOWN = "UNKNOWN",
	AO = "AO",
	TRANSFER = "TRANSFER"
}

export enum TransportStateFlag {
	DISABLED = "DISABLED",
	ENABLED = "ENABLED",
	BLOCKED = "BLOCKED"
}

export enum TransportAction {
	STOPPED = "STOPPED",
	TAKING = "TAKING",
	PUTTING = "PUTTING",
	MOVING = "MOVING"
}
